class AccountSettings.AllowedDomainsListView extends Backbone.View
  templateHeader: JST["backbone/templates/account_settings/allowed_domains/list"]
  templateRow: JST["backbone/templates/account_settings/allowed_domains/row"]

  events:
    'click .btn-add':         '_createNew'

  initialize: (@options = {}) ->
    @collection = @options.collection

  render: ->
    @$el.html(@templateHeader({self: @}))
    @body = @$el.find('tbody')
    @_renderList()
    @

  _renderList: ->
    @body.empty()
    _.each @collection.models, (mod) =>
      row = $(@templateRow({self: @, model: mod}))
      row.find('.action-delete').on('click', mod, @_destroy)
      row.find('.action-edit').on('click', mod, @_edit)
      @body.append(row)

  _afterCreate: (model) =>
    @collection.add(model)
    @_renderList()

  _afterUpdate: (model) =>
    @_renderList()

  _createNew: =>
    new_view = new AccountSettings.AllowedDomainsEditorView({model: new AccountSettings.AllowedDomain(), collection: @collection})
    new_view.bind('new:allowedDomain', @_afterCreate)
    new_view.render()

  _edit: (ev) =>
    edit_view =  new AccountSettings.AllowedDomainsEditorView({model: ev.data, collection: @collection})
    edit_view.bind('updated:allowedDomain', @_afterUpdate)
    edit_view.render()

  _destroy: (ev) =>
    translations =
      msg: I18n.t('account_settings.allowed_domains.delete.msg'),
      yes: I18n.t('account_settings.allowed_domains.delete.affirmative')

    model = ev.data
    noty {
      text: translations.msg,
      type: 'error'
      buttons: [
        {
          addClass: 'btn btn-primary', text: translations.yes, onClick: ($noty) =>
            $noty.close()
            model.destroy()
            @_removeFromTable(model.getId())
        },
        {
          addClass: 'btn btn-primary', text: 'No', onClick: ($noty) ->
            $noty.close()
        }
      ]
    }

  _removeFromTable: (id) =>
    @$el.find("#domain-#{id}").remove()